
import AWS from 'aws-sdk';
import { useState } from 'react';
// import * as AWS from 'aws-sdk';


const UploadImageService=()=>{
const [imageURL,setImageURL] =useState('')
const [iShowSpinner,setIShowSpinner] =useState(false)
let coreEnvironment: {
        awsAccountId: '198337867994',
        awsIdentityPoolId: 'us-east-1:93fa015c-a836-4bdc-a9f9-4ba1bf71c8ed',
        awsRegion: 'us-east-1',
        bucketUrl: 'https://corejs-videos-processed.s3.amazonaws.com/qa',
}



const S3_BUCKET = 'corejs-videos-processed';
const REGION = 'us-east-1';

AWS.config.update({
    credentials: new AWS.CognitoIdentityCredentials({
      AccountId: '198337867994',
      IdentityPoolId: 'us-east-1:93fa015c-a836-4bdc-a9f9-4ba1bf71c8ed',
    }),
    region: REGION,
  });

  AWS.config.getCredentials(err => {
    if (err) {
      throw new Error(err.message);
    }
  });
const myBucket = new AWS.S3({
    apiVersion: '2006-03-01',
  });

const handleUploadImageToS3=(paramsData:any)=>{    
  setIShowSpinner(true)
    myBucket.upload(paramsData,(err:any,data:any)=>{
        if (err) {
          setIShowSpinner(false)
           // console.log(err, 'there was an error uploading your file');
            }else{
              
           // console.log("data=====>",data)
            setImageURL(data?.Location)
            setTimeout(()=>{
              setIShowSpinner(false)
            },2000)
            }

    })

}

return{
    handleUploadImageToS3,
    imageURL,
    iShowSpinner
}

}


export default UploadImageService;